import { type ParentComponent, Show, Suspense } from "solid-js";
import { useWire } from "@core/wire";

export const MarketingLayout: ParentComponent = (props) => {
  const wire = useWire();
  return (
    <Show when={!wire.metadata.isDefault}>
      <Suspense>{props.children}</Suspense>
      {/* <Bug /> */}
    </Show>
  );
};
